const PRIMARY_BUTTON_PROPS = {
  variant: 'ghost',
  size: 's',
  bgColor: 'Interface-Onsurface',
  color: 'Interface-Onsurface',
  colorHover: 'Interface-Eleven',
  bgColorHover: 'Interface-Onsurface',
  colorActive: 'Interface-Eleven',
  bgColorActive: 'Interface-Onsurface',
  opacity: 20,
}

const SECONDARY_BUTTON_PROPS = {
  variant: 'ghost',
  size: 's',
  color: 'Interface-Onsurface',
  colorHover: 'Interface-Eleven',
}

export const getOnboardingButtonProps = (button, index = 0) => {
  if (index === 0) {
    return PRIMARY_BUTTON_PROPS
  }

  return button?.variant === 'secondary' ? SECONDARY_BUTTON_PROPS : PRIMARY_BUTTON_PROPS
}
